import styled from 'styled-components';
import PropTypes from 'prop-types';
import Editor from 'components/Editor';
import EditorToolbar from 'components/EditorToolbar';
import { forwardRef } from 'react';

const PageEditor = forwardRef((props, ref) => {
  return (
    <Wrapper>
      <EditorToolbar />
      <Editor
        ref={ref}
        initialValue={props.initialValue}
      />
    </Wrapper>
  );
});

PageEditor.propTypes = {
  onChangeEditor: PropTypes.func,
  textSuggestion: PropTypes.string,
  initialValue: PropTypes.string
}

export default PageEditor;

const Wrapper = styled.div`
  position: relative;
  width: 1080px;
  height: 100%;
  background: var(--lizzy-white);
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.25);
  margin: 16px auto;
  font-family: 'Arial';
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
`;